import type { FaireProductEntity } from "../../entity_types/product";

export const p_8za39ngd6v: FaireProductEntity = {
  token: "p_8za39ngd6v",
  type: "product",
  name: "Bro Knit Sweater, Wilderness",
  brandToken: "b_4ivwmhbmyd",
  brandName: "SpearmintLOVE",
  imageUrl:
    "https://cdn.faire.com/fastly/d88bff0ac0e92cc8f3d58e331c42e9f0a696150e2488c5dedfb87d9c22ffd9d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f9f7aa24a13c39cc7ea4e5c03522cee0be7fee43f6b827474a253fa649384460.jpeg",
    "https://cdn.faire.com/fastly/73b9126e0c97f72cca833f3db2ec22ba249dad3972842c45308cdeb9df98da71.jpeg",
  ],
  priceDollars: 21,
  description:
    "\nFor the coolest Brother! These cozy knit sweaters are perfectly oversized and made from 100% sheep wool. \n\n * Made from 100% Sheep Wool \n * Imported \nCARE INSTRUCTIONS\n\nWashing: hand wash recommended\nDry cleaning: do not dry clean\nBleaching: do not bleach\nDrying: hang dry\n",
  tags: [],
  msrpDollars: 42,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:56.292Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
